"use client";

import React from "react";
import { motion } from "framer-motion";
import {
  Facebook,
  Twitter,
  Mail,
  Phone,
  HelpCircle,
  FileText,
  User,
  Book,
  Info,
  Building,
  GraduationCap,
  Briefcase,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Image } from "antd";

const Footer = () => {
  const fadeInUp = {
    initial: { y: 20, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    transition: { duration: 0.5 },
  };

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Cột 1: Về chúng tôi */}
          <motion.div {...fadeInUp} className="space-y-4">
            <h3 className="text-xl font-bold mb-6 border-b border-teal-400 pb-2">
              VỀ CHÚNG TÔI
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <Info size={18} />
                <Link href="/about" className="hover:text-teal-100">
                  Giới thiệu
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <Building size={18} />
                <Link href="/partners" className="hover:text-teal-100">
                  Đối tác
                </Link>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} />
                <a href="tel:0902954563" className="hover:text-teal-100">
                  Tel: 0902 954 563
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} />
                <a
                  href="mailto:support@vieclamxanxuat.com"
                  className="hover:text-teal-100"
                >
                  Email: support@vieclamxanxuat.com
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Cột 2: Dành cho ứng viên */}
          <motion.div {...fadeInUp} className="space-y-4">
            <h3 className="text-xl font-bold mb-6 border-b border-teal-400 pb-2">
              DÀNH CHO ỨNG VIÊN
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <Briefcase size={18} />
                <Link href="/jobs" className="hover:text-teal-100">
                  Tìm việc làm
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <GraduationCap size={18} />
                <Link href="/career-guide" className="hover:text-teal-100">
                  Cẩm nang nghề nghiệp
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <User size={18} />
                <Link href="/profile" className="hover:text-teal-100">
                  Quản lý hồ sơ
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <HelpCircle size={18} />
                <Link href="/candidate-faq" className="hover:text-teal-100">
                  Hỗ trợ ứng viên
                </Link>
              </li>
            </ul>
          </motion.div>

          {/* Cột 3: Nhà tuyển dụng */}
          <motion.div {...fadeInUp} className="space-y-4">
            <h3 className="text-xl font-bold mb-6 border-b border-teal-400 pb-2">
              NHÀ TUYỂN DỤNG
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <Book size={18} />
                <Link href="/recruitment-guide" className="hover:text-teal-100">
                  Cẩm nang tuyển dụng
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <FileText size={18} />
                <Link href="/post-job" className="hover:text-teal-100">
                  Đăng tin tuyển dụng
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <User size={18} />
                <Link href="/employer-account" className="hover:text-teal-100">
                  Quản lý tài khoản
                </Link>
              </li>
              <li className="flex items-center space-x-2 hover:translate-x-2 transition-transform">
                <HelpCircle size={18} />
                <Link href="/employer-support" className="hover:text-teal-100">
                  Hỗ trợ nhà tuyển dụng
                </Link>
              </li>
            </ul>
          </motion.div>

          {/* Cột 4: Ứng dụng & Kết nối */}
          <motion.div {...fadeInUp} className="space-y-6">
            <h3 className="text-xl font-bold mb-6 border-b border-teal-400 pb-2">
              ỨNG DỤNG & KẾT NỐI
            </h3>
            <div className="space-y-4">
              <p className="font-medium">Quét mã QR</p>
              <div className="grid grid-cols-2">
                <Image
                  src="/img/qrastore.png"
                  alt="App Store QR"
                  width={120}
                  height={120}
                  className="p-2 rounded-lg"
                />

                <Image
                  src="/img/qrastore.png"
                  alt="App Store QR"
                  width={120}
                  height={120}
                  className="p-2 rounded-lg"
                />
              </div>
            </div>

            <div className="space-y-4">
              <p className="font-medium">Kết nối với chúng tôi</p>
              <div className="flex space-x-4">
                <Link
                  // href="https://facebook.com"
                  target="_blank"
                  className="hover:text-primary-hover text-black transition-colors bg-white p-2 rounded-full"
                >
                  <Facebook size={24} />
                </Link>
                <Link
                  target="_blank"
                  className="hover:text-primary-hover text-black transition-colors bg-white p-2 rounded-full"
                >
                  <Twitter size={24} />
                </Link>
                <Link
                  target="_blank"
                  className="hover:text-primary-hover text-black transition-colors bg-white p-2 rounded-full"
                >
                  <Mail size={24} />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-center mt-8 pt-8 border-t border-teal-400"
        >
          <p className="text-sm">
            2024 - Bản quyền thuộc về Vieclamxanxuat.com
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
